<template>
  <div class="relative flex h-52 w-52 flex-col items-center justify-center md:h-60 md:w-60">
    <BaseShape
      v-if="showBackgroundShape"
      shape="6-sided-cookie"
      class="text-surface-container absolute top-1/2 left-1/2 z-0 h-[120%] w-[120%] -translate-x-1/2 -translate-y-1/2"
    />
    <div class="z-10 flex flex-col items-center">
      <div>
        <span class="text-display-small md:text-display-large font-semibold">
          {{ numberOfFeedbacks }}
        </span>
        <span class="text-title-small"> /{{ numberOfQuestions }} </span>
      </div>
      <span class="text-label-small md:text-label-large">
        {{ $t('common.answer', numberOfFeedbacks) }}
      </span>
    </div>
    <div
      class="absolute top-1/2 left-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2 md:h-48 md:w-48"
    >
      <BaseWavyCircle
        :percentage="percentage"
        :thickness="thickness"
        :wavelength="wavelength"
        :amplitude="amplitude"
        :radius="80"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import BaseShape from '@/core/components/base/shapes/BaseShape.vue'
  import BaseWavyCircle from '@/core/components/base/progress-indicator/BaseWavyCircle.vue'

  interface Props {
    numberOfFeedbacks: number
    numberOfQuestions: number
    percentage: number
    showBackgroundShape?: boolean
    thickness?: number
    wavelength?: number
    amplitude?: number
  }

  withDefaults(defineProps<Props>(), {
    showBackgroundShape: false,
    thickness: 12,
    wavelength: 28,
    amplitude: 4,
  })
</script>
